<template>
  <van-popup :show="show" @update:show="$emit('update:show', $event)" :close-on-click-overlay="false"
    class="reward-dialog" round>
    <div class="reward-content">
      <!-- 顶部插图区域 -->
      <div class="reward-illustration">
        <!-- 加倍图片 -->
        <img :src="getAssetsFile('activity/jj.png')" alt="Reward" class="reward-image" />
      </div>

      <!-- 文字和按钮区域 -->
      <div class="reward-text color-[#6A6A6A]">
        <p class="reward-message color-[#6A6A6A]">
          {{ t("redouble.message") }}
        </p>
        <div v-if="IS_DOUBLE_WALLET" class="mb-[10px]">
          <div v-if="props.amount.amount">
            <span class="reward-amount">
              {{ VITE_symbol }}{{ numberFormat(props.amount.amount, { minDecimals: 2 }) }}</span>
          </div>
        </div>
        <div v-else class="mb-[10px]">
          <!-- 根据 currency 字段判断显示 Cash 还是 Bonus -->
          <div v-if="props.amount.amount">
            <span class="reward-amount">
              {{ VITE_symbol }}{{ numberFormat(props.amount.amount, { minDecimals: 2 }) }} 
              ({{ props.amount.currency === 'BOUND' ? t('bonus') : t('cash') }})
            </span>
          </div>
          <!-- 兼容旧逻辑：如果没有 currency 字段，使用 rewardBound -->
          <div v-if="!props.amount.currency && props.amount.rewardBound">
            <span class="reward-amount">{{ numberFormat(props.amount.rewardBound, {
              minDecimals: 2
            }) }} ({{ t('bonus') }})</span>
          </div>
        </div>
        <!-- 确认按钮 -->
        <div class="flex items-center justify-center">
          <div class="reward-button" @click="handleConfirm">
            {{ t("redouble.confirm") }}
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { numberFormat } from "@/utils/formatter";
import { getAssetsFile } from "@/utils/pub-use";
const VITE_symbol = import.meta.env.VITE_SYMBOL;
const IS_DOUBLE_WALLET = import.meta.env.VITE_IS_DOUBLE_WALLET;
const { t } = useI18n();
const router = useRouter();

interface Props {
  show: boolean;
  amount: {
    amount?: number;      // 加倍奖励金额（来自接口的 amount 字段）
    currency?: string;    // 货币类型：BOUND（彩金）或 CASH（现金）
    reward?: number;      // 保留兼容性
    rewardBound?: number; // 保留兼容性
  };
}

interface Emits {
  (e: "update:show", value: boolean): void;
  (e: "confirm"): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleConfirm = () => {
  emit("update:show", false);
  emit("confirm");
  // 跳转到充值页面
  router.push("/Deposito");
};
</script>

<style lang="scss" scoped>
.reward-dialog {
  width: 80%;
  max-width: 320px;
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.reward-content {
  padding-bottom: 0;
  text-align: center;
  background: transparent;
  border-radius: 16px;
}

.reward-illustration {
  margin-bottom: 0;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px 16px 0 0;
  position: relative;
  overflow: hidden;
  background: transparent;
}

.reward-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 2;
  border-radius: 16px 16px 0 0;
}

.reward-text {
  margin-bottom: 0;
  margin-top: -20px;
  background: white;
  padding: 20px;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.reward-message {
  font-size: 16px;
  color: #6a6a6a;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 20px;
}

.reward-amount {
  color: #ff4444;
  font-weight: bold;
  font-size: 18px;
}

.reward-button {
  background: linear-gradient(180deg, #3cc35f 0%, #3a9857 100%);
  color: white;
  padding: 10px 0;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  width: 45%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(19, 199, 105, 0.3);
}

.reward-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(19, 199, 105, 0.4);
}

.reward-button:active {
  transform: translateY(0);
}
</style>
